























































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import StepStateIcon from '@/components/Payroll/StepStateIcon.vue';
import PayrollRunStatus from '@/models/Payroll/PayrollRunStatus';
import TimesheetDto from '@/models/Timesheets/TimesheetDto';
import {
    PayrollRunDetailsModule,
    PayrollRunWorkerSummary,
} from '@/store/modules/payrollRunDetails';

@Component({
    name: 'PayrollRunWorkers',
    components: { StepStateIcon },
})
export default class extends GiganautVue {
    @Prop({ required: true }) runId!: string;
    @Prop({ required: true }) runStatus!: number;
    @Prop({ default: '' }) providerName!: string;

    activeTab = 0;

    newHeaders = [
        { text: this.Labels.worker, value: 'lastName', sortable: false },
        { text: 'Timesheets (sent/bound)', value: 'sentTimesheetCount', align: 'end', sortable: false, width: 170 },
        { text: 'Last error', value: 'workerSyncError', sortable: false },
    ];

    existingHeaders = [
        { text: this.Labels.worker, value: 'lastName', sortable: false },
        { text: 'Timesheets (sent/bound)', value: 'sentTimesheetCount', align: 'end', sortable: false, width: 170 },
        { text: 'Payroll reference', value: 'externalPayrollSystemId', sortable: false },
        { text: 'Payslip', value: 'payslipFetchedAt', align: 'center', sortable: false, width: 90 },
        { text: 'Holiday', value: 'holidayFetchedAt', align: 'center', sortable: false, width: 90 },
        { text: '', value: 'actions', align: 'center', sortable: false, width: 60 },
    ];

    rollbackDialog = false;
    rollbackWorkerId = '';
    rollbackWorkerName = '';
    rollbackWorkerBoundCount = 0;
    rollbackSelectedIds: string[] = [];

    get saving(): boolean { return PayrollRunDetailsModule.saving; }
    get workersLoading(): boolean { return PayrollRunDetailsModule.workersLoading; }
    get timesheetsLoading(): boolean { return PayrollRunDetailsModule.timesheetsLoading; }
    get workers(): PayrollRunWorkerSummary[] { return PayrollRunDetailsModule.workers; }

    get newWorkers(): PayrollRunWorkerSummary[] {
        return this.workers.filter(w => !w.workerSyncedAt);
    }

    get existingWorkers(): PayrollRunWorkerSummary[] {
        return this.workers.filter(w => !!w.workerSyncedAt);
    }

    // Sync only allowed while the run is editable. Once submitted, the run
    // is locked from worker pushes.
    get canSend(): boolean {
        return this.runStatus === PayrollRunStatus.Draft || this.runStatus === PayrollRunStatus.Submitting;
    }

    // Provider label used in the Send button — derived from the active
    // integration name so a different adapter just relabels automatically.
    // Falls back to a generic phrase when no integration is configured.
    get providerLabel(): string {
        return this.providerName || 'payroll system';
    }

    @Watch('runId', { immediate: true })
    async onRunIdChange(newVal: string) {
        if (!newVal) return;
        // Lazy — no-op if already loaded since the last invalidation.
        // Mutations elsewhere (bind/unbind/submit timesheets, ensureWorkers)
        // invalidate via setWorkersLoaded(false) so a subsequent view of
        // this tab triggers a fresh fetch.
        await PayrollRunDetailsModule.ensureWorkersLoaded(newVal);
    }

    workerName(item: PayrollRunWorkerSummary): string {
        return `${item.firstName || ''} ${item.lastName || ''}`.trim() || '—';
    }

    async onSend() {
        await PayrollRunDetailsModule.ensureWorkers(this.runId);
    }

    // The mistake-send recovery is blocked only at the lifecycle ends —
    // Draft (nothing sent) and Completed (settled) — mirroring the backend
    // guard; the backend also refuses mid-fetch via the sync locks.
    get canRollback(): boolean {
        return this.canManage(this.Permissions.Payroll)
            && this.runStatus !== PayrollRunStatus.Draft
            && this.runStatus !== PayrollRunStatus.Completed;
    }

    // The selected worker's SENT timesheets on this run — the pickable set.
    get rollbackCandidates(): TimesheetDto[] {
        if (!this.rollbackWorkerId) return [];
        return PayrollRunDetailsModule.timesheets.filter(
            t => t.workerId === this.rollbackWorkerId && !!t.externalPayrollSystemId);
    }

    // True when the selection covers EVERY timesheet the worker has bound
    // to the run (selection ⊆ sent ⊆ bound, so equal counts means full
    // coverage) — the backend will then drop their payroll_run_worker row,
    // which deserves a heads-up in the dialog.
    get rollbackRemovesWorker(): boolean {
        return this.rollbackSelectedIds.length > 0
            && this.rollbackSelectedIds.length === this.rollbackWorkerBoundCount;
    }

    async openRollbackDialog(item: PayrollRunWorkerSummary) {
        this.rollbackWorkerId = item.workerId;
        this.rollbackWorkerName = this.workerName(item);
        this.rollbackWorkerBoundCount = item.boundTimesheetCount;
        this.rollbackSelectedIds = [];
        this.rollbackDialog = true;
        // The candidate list reads from the run's timesheets collection,
        // which the user may not have visited yet this session.
        await PayrollRunDetailsModule.ensureTimesheetsLoaded(this.runId);
    }

    closeRollbackDialog() {
        this.rollbackDialog = false;
        this.rollbackWorkerId = '';
        this.rollbackWorkerName = '';
        this.rollbackWorkerBoundCount = 0;
        this.rollbackSelectedIds = [];
    }

    toggleRollbackSelection(id: string) {
        if (this.rollbackSelectedIds.includes(id)) {
            this.rollbackSelectedIds = this.rollbackSelectedIds.filter(x => x !== id);
        } else {
            this.rollbackSelectedIds = [...this.rollbackSelectedIds, id];
        }
    }

    async onConfirmRollback() {
        await PayrollRunDetailsModule.rollbackWorkerSentTimesheets({
            runId: this.runId,
            workerId: this.rollbackWorkerId,
            timesheetIds: this.rollbackSelectedIds,
        });
        this.closeRollbackDialog();
    }
}
